import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TURN_STYLES } from '@/styles/theme';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const Version = styled('p')({});

export const IconWrapper = styled('button')({
  display: 'grid',
  placeItems: 'center',
  marginLeft: '20px',
  padding: '2.5px',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease-in-out',

  '&:hover': {
    backgroundColor: TURN_STYLES.primaryAccentColorHover,
  },
});

export const Icon = styled(FontAwesomeIcon)({
  width: '24px',
  height: '24px',
  color: `${TURN_STYLES.primaryAccentColor} !important`,
});
